<template>
    <div v-bind:class="locale">
        <RouterView />
    </div>
</template>

<script lang="ts" setup>
    import { useAdBlock } from '@/composable/useAdBlock';
    import { i18n } from '@/core/lib/i18n';
    import { useMetadataOnce } from '@/core/oddsApi/composable/useMetadataOnce';

    useAdBlock();

    useMetadataOnce();

    const { locale } = i18n;
</script>

<style lang="scss">
    @import "@/scss/Home";
</style>
